import img1 from "./drevniky-1.jpg";
import img2 from "./drevniky-2.jpg";
import img3 from "./drevniky-3.jpg";
import img4 from "./drevniky-4.jpg";
import img5 from "./drevniky-5.jpg";
import img6 from "./drevniky-6.jpg";
import img7 from "./drevniky-7.jpg";
import img8 from "./drevniky-8.jpg";

export const drevnikyImages = [img1, img2, img3, img4, img5, img6, img7, img8];
